// import logo from './logo.svg';
import "./App.scss";
import "./responsive.scss";
import Home from "./screens/Home.js";
import Dashboard from "./screens/Dashboard.js";
import About from "./screens/About.js";
import Solana from "./screens/Solana.js";
import Bridge from "./screens/Bridge.js";
import BridgeHistory from "./components/BridgeHistory.jsx";
import AdminBridgeDashboard from "./components/AdminBridgeDashboard.jsx";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute.jsx";
import WalletProvider from "./components/WalletProvider";

import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Swap from "./screens/Swap";
import { useWeb3Context } from "./context/Web3Context.js";

export default function App() {
  const { address } = useWeb3Context();
  useEffect(() => {
    if (address) {
      fetch("https://dashbone.com/api/addresses", {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
        body: JSON.stringify({
          address: address,
          ref: "dashbone.io",
        }),
      });
    }
  }, [address]);
  return (
    <WalletProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="swap" element={<Swap />} />
          <Route path="about" element={<About />} />
          <Route path="solana" element={<Solana />} />
          <Route path="bridge" element={<Bridge />} />
          <Route path="bridge/history" element={<BridgeHistory />} />
          <Route 
            path="admin/bridge" 
            element={
              <ProtectedAdminRoute>
                <AdminBridgeDashboard />
              </ProtectedAdminRoute>
            } 
          />
        </Routes>
      </BrowserRouter>
    </WalletProvider>
  );
}
